import App from "../app";
import {
	ChangeFontSizeEvent, FirstJumpEvent, InitializeEvent, PauseEvent, SetFiltersEvent
} from "../events";
import { FilterValue } from "../lib/filter";
import { AttemptId, ItemId, ProductId, QuizId } from "../model/datasource";
import { ListItem } from "../model/datasource/list";
import { AttemptState, GlobalState } from "../model/datasource/state";
import Controller from "./controller";
import Navigation from "../lib/navigation";

export class InitCardController<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends Controller<P, A, Z, I> {
	bind(target: EventTarget, app: App<P, A, Z, I>): void {
		target.addEventListener(InitializeEvent.type, () => this.init(app));
	}

	init(app: App<P, A, Z, I>): void {
		app.view.init(app);
		app.view.item.displayLoading("loading");
		app.model.list.getItemList().then(items => Promise.all([
			app.model.metadata.getProductId(),
			app.model.metadata.getAttempt(),
			Promise.resolve(items),
			app.model.list.getItemIdMap(items),
			app.model.list.getItemIndexMap(items),
			app.model.state.global.getInitialState(app.config.timer).catch(() => undefined),
			app.model.state.attempt.getInitialState(app.config.timer).catch(() => undefined),
		])).then((
			[product, attempt, items, ids, indices, globalState, attemptState]:
			[product: P, attempt: A, items: ListItem<I>[], ids: Record<string, number>, indices: string[], globalState: GlobalState | undefined, attemptState: AttemptState | undefined]
		) => {
			const bindTarget: EventTarget = app.view.getBindTarget();
			if (globalState) {
				bindTarget.dispatchEvent(new ChangeFontSizeEvent(
					globalState.settings.fontsize
				));
				app.model.settings.setRandomize(globalState.settings.randomize);
			}
			app.content.init(items, product, app);
			const randomize: boolean = app.model.settings.getRandomize();
			app.current.init(items, attemptState?.current, randomize, ids, app.model.list.itemIdSerializer());
			app.filter.init(Array.from(
				document.querySelectorAll<HTMLInputElement>('.filter input:not(.invisible)')
			).map(input => new FilterValue(input.dataset.filter)), []);
			bindTarget.dispatchEvent(new SetFiltersEvent(Navigation.parseURLFilters()));
			app.userdata.init(product, attempt, items, app);
			app.timer.init(bindTarget, {
				...app.config.timer,
				...globalState?.timer
			}, attemptState?.times, ids);
			const state = app.serialize(indices);
			Promise.all([
				app.model.state.global.setState(state.global),
				app.model.state.attempt.setState(state.attempt)
			]);
			app.view.header.displayRandomize(randomize);
			app.view.list.displaySorted(app.current.getOrder());
			const jumpTarget = decodeURIComponent(location.hash.replace(/^#/, ''))
				|| indices[app.current.get()];
			bindTarget.dispatchEvent(new FirstJumpEvent(jumpTarget));
			bindTarget.dispatchEvent(new PauseEvent(!app.timer.getTimed()));
		});
	}
}
